import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (index) => {
    setOpenItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const faqData = [
    {
      question: "What is our ideal persona for a Fractional Fellow?",
      answer: (
        <div>
          <p><strong>Founder success = luck × drive × skill</strong></p>
          <ul>
            <li><strong>Luck</strong> = if the founder is the right person at the right place at the right time. Being early helps.</li>
            <li><strong>Drive</strong> = how ambitious and persistent founders are. Agency is key.</li>
            <li><strong>Skill</strong> = how good founders are, and how quickly they get better.</li>
          </ul>
          <h3>5 years or less of experience</h3>
          <p>Started to build credibility, industry experience, domain expertise, connections and the kind of relationships that can take a few years to cultivate. They've seen enough to be able to spot opportunities that others miss. They know the rules of their business—just enough to know how to break them. They also know which problems need to be solved because they have encountered those problems too many times themselves.</p>
        </div>
      )
    },
    {
      question: "Why does evaluating problem, solution and unfair advantages help us assess founder success?",
      answer: (
        <ul>
          <li><strong>Problem</strong> = helps us assess luck. Has the founder put themselves in a situation where they become the right person at the right place at the right time, ideally earlier than everyone else?</li>
          <li><strong>Solution</strong> = helps us assess drive. Is the founder ambitious and persistent enough to build an effective solution, even if it's built part-time? Does the founder have the agency to build an effective solution, even if they're in a chaotic environment?</li>
          <li><strong>Unfair advantages</strong> = helps us assess skill. Has the founder gotten so good so quickly that what they've built have become unfair advantages?</li>
        </ul>
      )
    },
    {
      question: "How do people hear about us?",
      answer: (
        <div>
          <p><strong>Inbound:</strong> students, alumni and working professionals who are already on our mailing list, or see our social media posts, or learn about us through word-of-mouth</p>
          <p><strong>Outbound:</strong> students and alumni who have shown interest in entrepreneurship</p>
          <p><strong>Alumni:</strong> We reach out to our alumni database, which includes all students who have taken entrepreneurship courses and attended entrepreneurship events at Stanford and Berkeley</p>
          <p><strong>Students:</strong> We reach out to all the students currently taking entrepreneurship courses at Stanford and Berkeley (eventually we can expand this pool)</p>
        </div>
      )
    },
    {
      question: "Why do people apply?",
      answer: (
        <ul>
          <li><strong>"Application":</strong> No busy work</li>
          <li><strong>Focus:</strong> focus on fractional founders</li>
          <li><strong>Feedback:</strong> on core deliverables for startup building</li>
        </ul>
      )
    },
    {
      question: "What is our timeline?",
      answer: (
        <p><strong>Cycle:</strong> Applications twice a year, and we run a "batch" once in the summer and once in the winter</p>
      )
    },
    {
      question: "What is our process?",
      answer: (
        <div>
          <p>Every cycle, we will have 2 rounds of reviewing all the documents you submitted, and 1 meeting with the investment committee before decisions go out.</p>
          <ol>
            <li><strong>First read:</strong> Shuo & Sandy</li>
            <li><strong>Second read:</strong> FEC & Venture Partners</li>
            <li><strong>Meeting:</strong> Investment Committee</li>
            <li><strong>Final:</strong> decisions sent</li>
          </ol>
        </div>
      )
    },
    {
      question: "Why is our process different from other funds/accelerators/fellowships?",
      answer: (
        <div>
          <p>We believe in no extra work. Everything we ask you to submit in the process should be something that you have already built or will build for your startup.</p>
          <p>We ask you to show, not tell.</p>
        </div>
      )
    },
    {
      question: "How will the documents uploaded be used?",
      answer: (
        <div>
          <p>We will review all the documents uploaded and use the evaluation criteria to score your "application" – we will share which percentile your application landed in, as well as all qualitative feedback we collect from our General Partners, Venture Partners and others on the Investment Committee.</p>
          <p>Our goal is to share feedback with you that might help you build faster and better.</p>
        </div>
      )
    },
    {
      question: "Why do we have an evaluation form?",
      answer: (
        <div>
          <p><strong>To quantify:</strong> Most investors can't quantify their investment decisions. Our goal is to leverage the evaluation form to quantify our decision-making process and provide a self assessment tool for founders.</p>
          <p><strong>To stay objective:</strong> Most investors claim to "invest in the best people" but that is subjective to judgement. Our goal is to stay objective by only asking "Yes" or "No" questions, so we can give objective feedback to founders on their areas of improvement.</p>
          <p><strong>To be specific:</strong> Most investors can't articulate exactly what they are looking for. In fact, some of the most promising startups struggle with fundraising, because they don't understand what investors are looking for. Our goal is to be very specific and tactical with our evaluation form.</p>
        </div>
      )
    },
    {
      question: "What do we expect from founders?",
      answer: (
        <div>
          <p>The reality is that fractional founders who are at the earliest stages of building haven't figured everything out. Even public companies don't have everything figured out.</p>
          <p>We want to reward founders for progress and support founders in growing to their next phase. To that end, the purpose of our evaluation is to understand the distance founders have travelled and where we can hopefully be helpful.</p>
          <p><strong>Case study:</strong> Jay scored highly across our evaluation form, and we identified that he was struggling to identify a very specific user/buyer/customer persona, so we ran a pop-up board to drill down on the ICP (ideal customer profile) and discuss growth strategies.</p>
        </div>
      )
    }
  ];

  return (
    <div className="faq">
      {/* Hero Section */}
      <section className="faq-hero">
        <div className="container">
          <div className="content-block">
            <h1 className="hero-title">Frequently Asked Questions</h1>
            <p className="hero-description">
              Learn more about the Fractional Fellowship Program and our selection process.
            </p>
          </div>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="section">
        <div className="container">
          <div className="faq-content">
            {faqData.map((item, index) => (
              <div key={index} className="faq-item">
                <button
                  className={`faq-question ${openItems[index] ? 'active' : ''}`}
                  onClick={() => toggleItem(index)}
                  aria-expanded={openItems[index]}
                >
                  <span>{item.question}</span>
                  <svg
                    className="faq-icon"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path d="M6 9l6 6 6-6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
                <div className={`faq-answer ${openItems[index] ? 'open' : ''}`}>
                  <div className="faq-answer-content">
                    {item.answer}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQ;